import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageView } from "../../lib/analytics";

const RouteTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!window.location.href.includes("localhost")) {
      initGA();
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (initialized) {
      trackPageView(location.pathname + location.search);
    }
  }, [initialized, location]);

  return null;
};

export default RouteTracker;
